module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('panel', {
    staticClass: "product"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  })], 1) : _c('panel', {
    attrs: {
      "title": ((_vm.product.sku) + " - " + (_vm.product.title)),
      "withFooter": false,
      "withBody": _vm.withBody
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.product.statusSynchronization
  }, [_vm._v(_vm._s(_vm.$t(("migration.statusSynchronization." + (_vm.product.statusSynchronization) + ".label"))))]), _vm._v(" "), _c('span', {
    staticClass: "badge",
    class: _vm.product.status
  }, [_vm._v(_vm._s(_vm.$t(("migration.status." + (_vm.product.status) + ".label"))))]), _vm._v(" "), _c('span', {
    staticClass: "badge",
    class: _vm.productActive
  }, [_vm._v(_vm._s(_vm.$t(("migration.statusProductMarketplace." + (_vm.product.active) + ".label"))))])]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-2@md vertical-center"
  }, [(_vm.image) ? _c('img', {
    staticClass: "photo",
    attrs: {
      "src": _vm.image,
      "alt": _vm.product.title
    }
  }) : _c('i', {
    staticClass: "icon icon-image2 no-photo"
  })]), _vm._v(" "), _c('div', {
    staticClass: "l-col-10@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('form-group', {
    attrs: {
      "label": "Módulo",
      "columns": 12
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moduleSelect),
      expression: "moduleSelect"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.moduleSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.modules), function(module) {
    return _c('option', {
      domProps: {
        "value": ((module.type) + "." + (module.identifier))
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t(((module.type) + ".label"))) + " " + _vm._s(_vm.$t(((module.identifier) + ".label"))) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Produto",
      "columns": 12
    }
  }, [_c('multiselect', {
    attrs: {
      "multiple": false,
      "options": _vm.products,
      "open-direction": "bottom",
      "placeholder": "Buscar por título/sku/ean/referencia",
      "label": "name",
      "track-by": "name",
      "loading": _vm.isLoading,
      "disabled": !_vm.moduleSelect,
      "searchable": true,
      "internal-search": false,
      "clear-on-select": true,
      "close-on-select": true,
      "show-labels": false,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "selectLabel": "Clique",
      "selectedLabel": ""
    },
    on: {
      "search-change": _vm.search
    },
    model: {
      value: (_vm.productSource),
      callback: function($$v) {
        _vm.productSource = $$v
      },
      expression: "productSource"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.productSource) ? _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('button', {
    staticClass: "btn btn--info u-floatRight",
    class: {
      'is-loading': _vm.isMigrationDoing
    },
    on: {
      "click": _vm.migrateProduct
    }
  }, [_vm._v(_vm._s(_vm.$t('migrate.label')))])]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7e22664","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductMigration/Card.vue
// module id = 3471
// module chunks = 0